<template lang="pug">
  include ../mixins
  div
    form-generator.ma--top_3xs(
      :form-model="formModel"
      :options="options"
      :formdata="innerFormdata"
    )
</template>

<script>
export default {
  name: 'location-form',
  components: {
    'form-generator': () => import('@/js/components/Forms/FormGenerator'),
  },
  props: {
    options: Object,
    formdata: Object,
  },
  data() {
    return {
      innerFormdata: this.formdata,
      formModel: [
        {
          component: 'control-multiselect',
          cols: '12 4-sm',
          view: 'multiselect',
          rules: 'required',
          className: 'common-multiselect common-multiselect--white',
          inputLabel: this._('Выберите город'),
          placeholder: this._('Город'),
          labelClass: 'form__label form__label--white',
          model: 'city',
          required: true,
          options: 'citiesList',
          trackBy: 'id',
          label: 'title',
          name: 'city',
          allowEmpty: false,
        },
        {
          component: 'control-multiselect',
          cols: '12 4-sm',
          view: 'multiselect',
          rules: 'required',
          className: 'common-multiselect common-multiselect--white',
          inputLabel: this._('Выберите школу'),
          placeholder: this._('Школа'),
          labelClass: 'form__label form__label--white',
          model: 'school',
          required: true,
          options: 'schoolsList',
          trackBy: 'id',
          label: 'title',
          name: 'school',
          allowEmpty: false,
        },
        {
          component: 'control-multiselect',
          cols: '12 4-sm',
          view: 'multiselect',
          rules: 'required',
          className: 'common-multiselect common-multiselect--white',
          inputLabel: this._('Какого возраста ученик'),
          placeholder: this._('Возраст'),
          labelClass: 'form__label form__label--white',
          model: 'ageGroup',
          required: true,
          options: 'ageGroupsList',
          trackBy: 'id',
          label: 'title',
          name: 'ageGroup',
          allowEmpty: false,
        },
      ],
    }
  },
}
</script>
